import {
  SET_FEED_STATE,
  SET_USER_FOLLOW,
  SET_PRODUCT_LIKE,
  SET_PRODUCT_UNLIKE,
  SET_USER_UNFOLLOW
} from '@app/+feed/store/actions';

export interface IFeedState {
  cards: any;
  users: any;
  products: any;
  map: string[];
}

export const feedStateDefault: IFeedState = {
  cards: [],
  users: [],
  products: [],
  map: []
};

export function reducer(state: IFeedState = feedStateDefault, { type, payload }) {
  switch (type) {
    case SET_FEED_STATE:
      return {
        ...state,
        cards: payload.entities.cards,
        users: Object.entries(payload.entities.actor),
        products: Object.entries(payload.entities.orderedProducts),
        map: payload.result
      };
    case SET_USER_FOLLOW:
      return {
        ...state,
        users: state.users.map(user => {
          return user[0] === payload
            ? [
                user[0],
                {
                  ...user[1],
                  isFollowed: true
                }
              ]
            : [...user];
        })
      };
    case SET_USER_UNFOLLOW:
      return {
        ...state,
        users: state.users.map(user => {
          return user[0] === payload
            ? [
                user[0],
                {
                  ...user[1],
                  isFollowed: false
                }
              ]
            : [...user];
        })
      };
    case SET_PRODUCT_LIKE:
      return {
        ...state,
        products: state.products.map(product => {
          return product[0] === payload
            ? [
                product[0],
                {
                  ...product[1],
                  likesCount: product[1].likesCount + 1
                }
              ]
            : [...product];
        })
      };
    case SET_PRODUCT_UNLIKE:
      return {
        ...state,
        products: state.products.map(product => {
          return product[0] === payload
            ? [
                product[0],
                {
                  ...product[1],
                  likesCount: product[1].likesCount - 1
                }
              ]
            : [...product];
        })
      };
    default:
      return state;
  }
}

export const arrayToObj = array => {
  const output = array.reduce((accum, [key, value]) => {
    accum[key] = value;
    return accum;
  }, {});
  return output;
};

export const getState = (state: IFeedState) => {
  return {
    ...state,
    users: arrayToObj(state.users),
    products: arrayToObj(state.products)
  };
};
